import React from 'react';
import LazyRoute from 'lazy-route';
import { Route, BrowserRouter,Switch} from 'react-router-dom';
import Index from 'views/index/Index';
import SubscriberList from 'views/subscriber-list/SubscriberList';
import utils from 'common/js/utils';
import Header from 'common/components/header/Header';
import Tabbar from 'common/components/tabbar/Tabbar';


export default class Router extends React.Component{
    constructor(props) {
        super(props);
        this.search = window.location.search;
        this.hideHeader = utils.hideHeader;
        this.state={
            showHeaderAndFooter: true
        };

        this.hideComComponent = this.hideComComponent.bind(this);
        this.showComComponent = this.showComComponent.bind(this);
    }

    hideComComponent() {
        this.setState({
            showHeaderAndFooter: false
        })
    }

    showComComponent() {
        this.setState({
            showHeaderAndFooter: true
        });
    }

    render() {
        
        return (
            <BrowserRouter basename="/liveoperation">
                    <div className={"g-page" + (this.hideHeader? " hideHeader" : "")}>
                        { (this.state.showHeaderAndFooter && !this.hideHeader) ? <Header search={this.search} fShowPayPanel={this.props.fShowPayPanel} isWx={utils.isWx}/> : ''}

                        <Switch>
                            <Route exact
                                   path="/"
                                   render={(props) => (
                                        <Index {...this.props} {...props} showComComponent={this.showComComponent}/>
                                   )} />
                            <Route exact
                                   path="/subscriber"
                                   render={(props) => (
                                        <SubscriberList {...this.props} {...props} showComComponent={this.showComComponent}/>
                                   )} />}
                            />

                            {/*<Route exact
                                   path="/subscriber"
                                   component={(props) => <LazyRoute {...props} component={import('views/subscriber-list/main')} />}
                            />*/}

                            {/* <Route exact
                                   path="/:rid"
                                   render={(props) => (
                                        <Room {...this.props} {...props}/>
                                   )} />}*/}
	                        
	                        <Route exact
	                               path="/yy/:rid"
	                               render={(props) => <LazyRoute {...props} {...this.props}  hideComComponent={this.hideComComponent} component={import('views/room/Room')} />}
	                        />

                            <Route path="/:rid"
                                   render={(props) => <LazyRoute {...props} {...this.props}  hideComComponent={this.hideComComponent} component={import('views/room/Room')} />}
                            />

                        </Switch>
                        { this.state.showHeaderAndFooter && !this.hideHeader ? <Tabbar search={this.search}/>: ''}
                    </div>

            </BrowserRouter>
        )
    }
}


// WEBPACK FOOTER //
// ./src/common/components/Router.jsx